import { parseZonedDateTime } from '@rematter/common/dateTime';
import { CustomAttributeEntityType } from '@rematter/frontend-lib-api-client';

import { CustomAttributeRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useCustomAttributeDefinitionsQuery = createQueryHook(
  'core.customAttributes',
  ({ entityType }: { entityType: CustomAttributeEntityType }) => ({
    customAttributeDefinitions: {
      __args: {
        filter: {
          entityTypes: [entityType],
        },
      },
      __scalar: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
      constraints: {
        __scalar: true,
        selectOptions: true,
      },
    },
  }),
  {
    select: (data): CustomAttributeRecord[] =>
      data.customAttributeDefinitions?.map((att) => ({
        id: att.id,
        name: att.name,
        dataType: att.dataType,
        isDisabled: att.isDisabled,
        order: att.order,
        entityType: att.entityType,
        constraints: att.constraints,
        createdAt: parseZonedDateTime(att.timestamps.createdAt),
        updatedAt: parseZonedDateTime(att.timestamps.updatedAt),
      })) ?? [],
  },
);
